import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
	// apiKey: process.env.apiKey,
	// authDomain: process.env.authDomain,
	// projectId: process.env.projectId,
	// storageBucket: process.env.storageBucket,
	// messagingSenderId: process.env.messagingSenderId,
	// appId: process.env.appId
	apiKey: 'AIzaSyAqtANyJKDBCtCNOgmOVAHhatrx7HpPIIk',
	authDomain: 'todo-react-2bd43.firebaseapp.com',
	projectId: 'todo-react-2bd43',
	storageBucket: 'todo-react-2bd43.appspot.com',
	messagingSenderId: '611710081016',
	appId: '1:611710081016:web:226f9d22d9d8ce9e79a80d'
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
